export class Lead {

	constructor() {
		this.yaCounter = yaCounter7616791;
		sbjs.init();
	}

	sendZapis(parent) {
		this.send(parent, 1, 'zapis');
		return false;
	}

	sendCoupon(parent) {
		this.send(parent, 10, 'coupon');
		return false;
	}

	sendVopros(parent) {
		this.send(parent, 5, 'vopros');
		return false;
	}

	sendOtzyv(parent) {
		this.send(parent, 2, 'otzyv');
		return false;
	}

	sendSubscribe(parent) {
		this.send(parent, 25, 'subscribe');
		return false;
	}

	sendPrice(parent) {
		this.send(parent, 14, 'calc');
		return false;
	}

	sendWork(parent) {
		this.send(parent, 32, 'work');
		return false;
	}

	async getRecaptchaToken() {
		let recpatchaSelector = document.querySelector('meta[name="captcha"]');
		let recaptchaToken = "";
		if (recpatchaSelector) {
			let recpatchaKey = recpatchaSelector.content;
			recaptchaToken = await grecaptcha.execute(recpatchaKey, { action: 'submit' });
		}
		return recaptchaToken;
	}

	async send(parent, mid, leadName) {
		$(document).css('cursor', 'wait');
		var el = $(parent);
		el.addClass('loader');

		let recaptchaToken = await this.getRecaptchaToken(); // Получаем токен reCAPTCHA
		console.log("reCAPTCHA Token:", recaptchaToken);

		let src = sbjs.get.current.src + '/' + sbjs.get.current.mdm;
		let _y = this.yaCounter;

		var submit = el.find("input[type='submit']");
		console.log(el.serialize());

		$.ajax({
			url: "/ajax.php?mid=" + mid,
			type: 'POST',
			data: el.serialize() + '&mode=send_request&src=' + src + '&call_value=' + window.call_value + '&token=' + recaptchaToken, // Передаем токен
			dataType: "json",
			beforeSend: function (jqXHR, settings) {
				submit.prop('disabled', true);

				var credentials = Comagic.getCredentials();
				settings.data += '&' + $.param(credentials);
			},
			success: function (res) {
				if (res['success']) {
					_y.reachGoal('lead');
					if (mid == 32) {
						VK.Goal('vakansiya');
					}

					submit.prop('disabled', true);

					if (mid == 10) {
						el.html('<div class="success">Ваш номер купона: ' + res['id'] + '. Для того чтобы воспользоваться скидкой Вам достаточно будет назвать лишь Ваше имя и номер купона.</div>');
					} else if (mid == 25) {
						el.html('<div class="success">Спасибо за подписку на наши новости!</div>');
					} else if (mid == 5) {
						el.html('<div class="success">Спасибо за Ваш вопрос. Мы свяжемся с Вами в ближайшее время!</div>');
					} else if (mid == 2) {
						el.html('<div class="success">Спасибо за Ваше сообщение. При необходимости мы свяжемся с Вами в ближайшее время!</div>');
					} else {
						el.html('<div class="success">Спасибо за Вашу заявку. Мы свяжемся с Вами в ближайшее время!</div>');
						setTimeout(function () { popup.close() }, 5000);
					}

					$(document).css('cursor', 'auto');
					el.removeClass('loader');

				} else {
					alert('Ошибка: ' + res['error'] + '. Пожалуйста, повторите попытку или свяжитесь с нами. Приносим извинения за неудобства.');
					$(document).css('cursor', 'auto');
					el.removeClass('loader');
				}
			},
			error: function (e) {
				console.log(e);
			}
		});
	}

	captureFiles(parent)
	{
		let files = parent.files;
		let el = $(parent);
		let block = el.closest('.form__row');

		var url = '/ajax.php?mid=32&mode=put_file';

		for (var i = 0; i < files.length; i++)
		{
			var file = files[i];
			if (file.type.match(/image.*/))
			{
				var reader = new FileReader();
				reader.onload = (function(aImg) {
					return function(e) {
						aImg.attr('src', e.target.result);
					};
				})(block.find('img.preview'));
	      		reader.readAsDataURL(file);

			}

			this.uploadFile(file, url, block);
		}
	}

	uploadFile(file, url, el)
	{
		let reader = new FileReader();
		el = el.closest('.form__row');
		let form = el.closest('form');
		form.find('input[type=submit]').prop('disabled', true);

	  	reader.onload = function() {
		    let xhr = new XMLHttpRequest();

			xhr.upload.addEventListener("progress", function(e) {
				if (e.lengthComputable) {
					let progress = (e.loaded * 100) / e.total;
					/* ... обновляем инфу о процессе загрузки ... */
					el.find('a.adv_img_a .hold').css('width', (100-progress) + '%');

					el.find('.circle-outline').text('Загрузка...' + Math.round(progress) + '%');
				}
			}, false);

		    /* ... можно обрабатывать еще события load и error объекта xhr.upload ... */

			xhr.onreadystatechange = function () {
				if (this.readyState == 4) {
					if(this.status == 200) {
						/* ... все ок! смотрим в this.responseText ... */
						//alert(this.responseText);
						let res = $.parseJSON(this.responseText);

						el.find('input, select').attr('disabled', false);
						el.find('a.adv_img_a .hold').remove();
						el.find('a.adv_img_a').attr('href', res.filename);
						el.find('input[type=text]').val(res.name);

						el.find('.circle-outline').text(res.name);
						el.find('input[type=hidden].adv_img_filename').val(res.filename);
						el.find('input[type=hidden].filename').val(res.filename);
						form.find('input[type=submit]').prop('disabled', false);
					} else {
						/* ... ошибка! ... */
						el.find('.circle-outline').text('Ошибка загрузки');
						form.find('input[type=submit]').prop('disabled', false);
					}
				}
			};

		    xhr.open("POST", url);

		   	var formData = new FormData();
		   	formData.append('myFile', file);
		   	xhr.send(formData);
		};

		// Читаем файл
		reader.readAsBinaryString(file);
	}
}
